import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { AppInsightsService } from 'src/app/services/app-insights.service';

@Injectable()
export class MSALInterceptorInterceptor implements HttpInterceptor {
  constructor(
    private authService: AuthService,
    private appInsightService: AppInsightsService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let modifiedReq = req;

    // 🔹 Get email from AuthService
    const userEmail = this.authService.getUserEmail();

    // 🔹 Add ?userEmail=... ONLY for this API
    if (userEmail && req.url.includes('/api/getAdgroupExtraction')) {
      modifiedReq = req.clone({
        setParams: {
          ...this.copyParams(req),
          userEmail: userEmail, // already lowercased in getUserEmail()
        },
      });
    }

    return next.handle(modifiedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (
          error?.headers?.get('x-powerbi-error-info') === 'TokenExpired' ||
          error?.error?.code === 'TokenExpired'
        ) {
          this.authService
            .refreshToken()
            .then((res) => {
              location.reload();
            })
            .catch((err) => {
              console.log('LogOff Issue Analysis::', err);
              this.appInsightService.logException(err, 3);
              this.authService.signOut();
            });
        }
        return throwError(error);
      })
    );
  }

  // Keep existing query params and add new one
  private copyParams(req: HttpRequest<any>): Record<string, string> {
    const params: Record<string, string> = {};
    req.params.keys().forEach((key) => {
      const value = req.params.get(key);
      if (value !== null) params[key] = value;
    });
    return params;
  }
}
